import React, { Suspense, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Card, Avatar } from 'antd';
import { EditOutlined, FileSearchOutlined , EllipsisOutlined, SettingOutlined, DownloadOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
import '../styles/styles.css'
import LogoCluster from '../assets/img/LogoClusterEnfermedades.png'
import {InputBar} from '../components/Input'
import {deleteAlert} from '../components/Alerts'
import {Link} from 'react-router-dom'
import {Img} from 'react-image'
import LogoFECOERCardDisplay from '../assets/img/Landing_Logo_Fecoer.png'
import Divider from '@material-ui/core/Divider';
import {Howl, Howler} from 'howler';
import AudioPlayer from 'react-h5-audio-player';

const { Meta } = Card;

const Book = styled.div`
-webkit-box-shadow: 4px 2px 10px -4px rgba(48, 50, 50, 0.75);
-moz-box-shadow:    4px 2px 10px -4px rgba(48, 50, 50, 0.75);
box-shadow:         4px 2px 10px -4px rgba(48, 50, 50, 0.75);
`
const BookTitle = styled.h1`
font-family: 'Acherus Grotesque';
font-size: 1.4rem;
margin: 0px 30px;
white-space:break-spaces !important;
text-align:left;
font-weight:900;
` 

const BookData = styled.li`
text-overflow: ellipsis;
list-style-type: none;
/* white-space: nowrap;
overflow: hidden;  */
width:100%;
text-align:left;
font-weight: 500;
font-size:1.2rem;
`
const ActionButton = styled.div`
width:100%;
background-color: ${props => props.background || "#6C0E60"} ;
color:${props => props.color || "white"} ;
padding:4% 0%;
&:hover{
    background-color:${props => props.color || "white"};
    color:${props => props.background || "#6C0E60"} ;
}
`

function camelCaseProfesional(str) { 
    var regex = 
    /[.,;:A-Z\xC0-\xD6\xD8-\xDE](?:[., \x41-\x5a\xc0-\xd6\xd8-\xde\u0100\u0102\u0104\u0106\u0108\u010a\u010c\u010e\u0110\u0112\u0114\u0116\u0118\u011a\u011c\u011e\u0120\u0122\u0124\u0126\u0128\u012a\u012c\u012e\u0130\u0132\u0134\u0136\u0139\u013b\u013d\u013f\u0141\u0143\u0145\u0147\u014a\u014c\u014e\u0150\u0152\u0154\u0156\u0158\u015a\u015c\u015e\u0160\u0162\u0164\u0166\u0168\u016a\u016c\u016e\u0170\u0172\u0174\u0176\u0178\u0179\u017b\u017d\u0181\u0182\u0184\u0186\u0187\u0189-\u018b\u018e-\u0191\u0193\u0194\u0196-\u0198\u019c\u019d\u019f\u01a0\u01a2\u01a4\u01a6\u01a7\u01a9\u01ac\u01ae\u01af\u01b1-\u01b3\u01b5\u01b7\u01b8\u01bc\u01c4\u01c5\u01c7\u01c8\u01ca\u01cb\u01cd\u01cf\u01d1\u01d3\u01d5\u01d7\u01d9\u01db\u01de\u01e0\u01e2\u01e4\u01e6\u01e8\u01ea\u01ec\u01ee\u01f1\u01f2\u01f4\u01f6-\u01f8\u01fa\u01fc\u01fe\u0200\u0202\u0204\u0206\u0208\u020a\u020c\u020e\u0210\u0212\u0214\u0216\u0218\u021a\u021c\u021e\u0220\u0222\u0224\u0226\u0228\u022a\u022c\u022e\u0230\u0232\u023a\u023b\u023d\u023e\u0241\u0243-\u0246\u0248\u024a\u024c\u024e][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)?(?:[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)+|(?:[\x41-\x5a\xc0-\xd6\xd8-\xde\u0100\u0102\u0104\u0106\u0108\u010a\u010c\u010e\u0110\u0112\u0114\u0116\u0118\u011a\u011c\u011e\u0120\u0122\u0124\u0126\u0128\u012a\u012c\u012e\u0130\u0132\u0134\u0136\u0139\u013b\u013d\u013f\u0141\u0143\u0145\u0147\u014a\u014c\u014e\u0150\u0152\u0154\u0156\u0158\u015a\u015c\u015e\u0160\u0162\u0164\u0166\u0168\u016a\u016c\u016e\u0170\u0172\u0174\u0176\u0178\u0179\u017b\u017d\u0181\u0182\u0184\u0186\u0187\u0189-\u018b\u018e-\u0191\u0193\u0194\u0196-\u0198\u019c\u019d\u019f\u01a0\u01a2\u01a4\u01a6\u01a7\u01a9\u01ac\u01ae\u01af\u01b1-\u01b3\u01b5\u01b7\u01b8\u01bc\u01c4\u01c5\u01c7\u01c8\u01ca\u01cb\u01cd\u01cf\u01d1\u01d3\u01d5\u01d7\u01d9\u01db\u01de\u01e0\u01e2\u01e4\u01e6\u01e8\u01ea\u01ec\u01ee\u01f1\u01f2\u01f4\u01f6-\u01f8\u01fa\u01fc\u01fe\u0200\u0202\u0204\u0206\u0208\u020a\u020c\u020e\u0210\u0212\u0214\u0216\u0218\u021a\u021c\u021e\u0220\u0222\u0224\u0226\u0228\u022a\u022c\u022e\u0230\u0232\u023a\u023b\u023d\u023e\u0241\u0243-\u0246\u0248\u024a\u024c\u024e][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)+(?![a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F])|[\d]+|[\u2700-\u27BF]|[^\x00-\x2F\x3A-\x40\x5B-\x60\x7b-\xBF\xD7\xF7\u2000-\u206F\s\uFEFF\xA0]+/g;
    var match = str.match(regex);
    let result = "";

      for(let i = 0 , len = match.length; i < len; i++) {
        let currentStr = match[i];
        let tempStr = currentStr.toLowerCase()
        let lengthcurrentstr = currentStr.length;
        let nextStr = currentStr.toLowerCase()

       /*  if(i === 0 || i != 1) {
            tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
        } */

        if(tempStr.includes("- ")){
            tempStr = tempStr.replace("- ","")
        }

        tempStr = tempStr + " "

        if(nextStr !== undefined){
            if(nextStr.includes("- ")){
                tempStr = tempStr.substr(-tempStr.length,tempStr.length-1)
            }
        }

        if(i === 0){
            tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1) + " ";
        }

        if(tempStr.includes(".")){
            tempStr = tempStr.substr(0,3).toUpperCase()+ tempStr.substr(3);
        }

        result += tempStr;
      }

      let FinalResult = result.replace(/([a-z])([A-Z])/g, '$1 $2')
      return FinalResult
      //
}
function camelCaseTitle(str) { 
    var regex = 
    /(?:[, \x41-\x5a\xc0-\xd6\xd8-\xde\u0100\u0102\u0104\u0106\u0108\u010a\u010c\u010e\u0110\u0112\u0114\u0116\u0118\u011a\u011c\u011e\u0120\u0122\u0124\u0126\u0128\u012a\u012c\u012e\u0130\u0132\u0134\u0136\u0139\u013b\u013d\u013f\u0141\u0143\u0145\u0147\u014a\u014c\u014e\u0150\u0152\u0154\u0156\u0158\u015a\u015c\u015e\u0160\u0162\u0164\u0166\u0168\u016a\u016c\u016e\u0170\u0172\u0174\u0176\u0178\u0179\u017b\u017d\u0181\u0182\u0184\u0186\u0187\u0189-\u018b\u018e-\u0191\u0193\u0194\u0196-\u0198\u019c\u019d\u019f\u01a0\u01a2\u01a4\u01a6\u01a7\u01a9\u01ac\u01ae\u01af\u01b1-\u01b3\u01b5\u01b7\u01b8\u01bc\u01c4\u01c5\u01c7\u01c8\u01ca\u01cb\u01cd\u01cf\u01d1\u01d3\u01d5\u01d7\u01d9\u01db\u01de\u01e0\u01e2\u01e4\u01e6\u01e8\u01ea\u01ec\u01ee\u01f1\u01f2\u01f4\u01f6-\u01f8\u01fa\u01fc\u01fe\u0200\u0202\u0204\u0206\u0208\u020a\u020c\u020e\u0210\u0212\u0214\u0216\u0218\u021a\u021c\u021e\u0220\u0222\u0224\u0226\u0228\u022a\u022c\u022e\u0230\u0232\u023a\u023b\u023d\u023e\u0241\u0243-\u0246\u0248\u024a\u024c\u024e][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)?(?:[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)+|(?:[\x41-\x5a\xc0-\xd6\xd8-\xde\u0100\u0102\u0104\u0106\u0108\u010a\u010c\u010e\u0110\u0112\u0114\u0116\u0118\u011a\u011c\u011e\u0120\u0122\u0124\u0126\u0128\u012a\u012c\u012e\u0130\u0132\u0134\u0136\u0139\u013b\u013d\u013f\u0141\u0143\u0145\u0147\u014a\u014c\u014e\u0150\u0152\u0154\u0156\u0158\u015a\u015c\u015e\u0160\u0162\u0164\u0166\u0168\u016a\u016c\u016e\u0170\u0172\u0174\u0176\u0178\u0179\u017b\u017d\u0181\u0182\u0184\u0186\u0187\u0189-\u018b\u018e-\u0191\u0193\u0194\u0196-\u0198\u019c\u019d\u019f\u01a0\u01a2\u01a4\u01a6\u01a7\u01a9\u01ac\u01ae\u01af\u01b1-\u01b3\u01b5\u01b7\u01b8\u01bc\u01c4\u01c5\u01c7\u01c8\u01ca\u01cb\u01cd\u01cf\u01d1\u01d3\u01d5\u01d7\u01d9\u01db\u01de\u01e0\u01e2\u01e4\u01e6\u01e8\u01ea\u01ec\u01ee\u01f1\u01f2\u01f4\u01f6-\u01f8\u01fa\u01fc\u01fe\u0200\u0202\u0204\u0206\u0208\u020a\u020c\u020e\u0210\u0212\u0214\u0216\u0218\u021a\u021c\u021e\u0220\u0222\u0224\u0226\u0228\u022a\u022c\u022e\u0230\u0232\u023a\u023b\u023d\u023e\u0241\u0243-\u0246\u0248\u024a\u024c\u024e][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)+(?![a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F])|[\d]+|[\u2700-\u27BF]|[^\x00-\x2F\x3A-\x40\x5B-\x60\x7b-\xBF\xD7\xF7\u2000-\u206F\s\uFEFF\xA0]+/g;
    var match = str.match(regex);
    let result = "";
    

      for(let i = 0 , len = match.length; i < len; i++) {
        let currentStr = match[i];
        let tempStr = currentStr.toLowerCase();
        if(i != 0 || i != 1) {
          // convert first letter to upper case (the word is in lowercase) 
            tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
        }
        result +=tempStr;
      }
      return result.replace(/([a-z])([A-Z])/g, '$1 $2')
      //.replace(/([a-zA-Z])([A-Z])([a-z])/g, '$1 $2$3')
} 

function camelCase(str) { 
    var regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[,;a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
    var match = str.match(regex);
    let result = "";

    
    if(match !== null){
      for(let i = 0 , len = match.length; i < len; i++) {
        let currentStr = match[i];
        let tempStr = currentStr.toLowerCase();
        if(i != 0 || i != 1) {
          // convert first letter to upper case (the word is in lowercase) 
            tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1) + " ";
        }
        result +=tempStr;
      }
      return result.replace(/([a-z])([A-Z])/g, '$1 $2')
    }
    else{
        return null
    }
      //.replace(/([a-zA-Z])([A-Z])([a-z])/g, '$1 $2$3')
} 


const CardLibrary = (props) => { 
    
    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    return(
                    <Book>
                        <Card
                            key={props.info.id}
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:700 }}
                            className="cardbox-shadow"
                            /* cover={
                                <InputBar backgroundColor="#f205cb" widthbar="100%" heightbar="20px"/>
                            } */
                            actions={[
                            <Link onClick={topFunction} to={`/biblioteca/${props.info.id}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp; <FileSearchOutlined key="seemore" /></ActionButton></Link>,
                            <a target="_blank" href={props.info.Url_orig}><ActionButton background="#130315" color="white">Abrir &nbsp; <DownloadOutlined  key="download" /></ActionButton></a>
                            ]}
                        >
                            <Meta
                            title={<BookTitle>{props.info.titulo_orig}</BookTitle>}
                            description={
                                <div>
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Autores : </strong>{props.info.Autores_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Año : </strong>{props.info.Fecha}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Revista : </strong>{props.info.titulo_secundario_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Numero : </strong>{props.info.Numero}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Volumen : </strong>{props.info.Volumen}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Palabras Clave : </strong>{props.info.PalabrasClave_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Idioma : </strong>{
                                              props.info.Idioma == "Espanol" ? "Español" : props.info.Idioma_orig  
                                          }</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}


const CardNormas = (props) => { 
    let NombreNormasCamel = props.info.Nombre
    let PalabrasClaveNormas = props.info.PalabrasClave

    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    return(
                    <Book>
                        <Card
                            key={props.info.id}
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:500 }}
                            className="cardbox-shadow"
                            cover={
                                <InputBar backgroundColor="#440A78" widthbar="100%" heightbar="20px"/>
                            }
                            actions={[
                            <Link onClick={topFunction} to={`/normativa/${props.info.id}`} params={{idValue:`${props.info.id}`}}><ActionButton background="#440A78" color="white">Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                            <a target="_blank" href={props.info.URL_orig}><ActionButton background="#130315" color="white"> Abrir &nbsp; <DownloadOutlined  key="download" /></ActionButton></a>
                            ]}
                        >
                            <Meta
                            title={<BookTitle>{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div>
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#440A78"}}>Tipo : </strong>{props.info.TipoNorma_orig}</BookData>
                                          <BookData><strong style={{color:"#440A78"}}>Entidad: </strong>{props.info.Entidad_orig}</BookData>
                                          <BookData><strong style={{color:"#440A78"}}>Palabras Clave : </strong>{props.info.PalabrasClave_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}
const CardPlatform = (props) => { 
    return(
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:700 }}
                            className="cardbox-shadow"
                            cover={
                                <img style={{minWidth:"10%",maxWidth:"300px", padding:"10px 10%", margin:"0", display:"revert"}} src={props.info.LogoURL_orig} onError={(e)=>{e.target.src = 'https://www.mpinforma.com/images/demo/LOGOS_FECOER/Landing_Logo_Fecoer.png'}}/>
                            }
                            actions={[
                            <a target="_blank" href={props.info.URL_orig}>
                                <ActionButton>
                                Ir a página principal
                                </ActionButton>
                            </a>,
                            ]}
                        >
                            <Meta
                            title={<BookTitle>{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div>
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Descripción : </strong>{props.info.Descripcion_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}

const CardOrganizacion = (props) => { 
    return(
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:580, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <img style={{minWidth:"10%",maxWidth:"300px", padding:"10px 10%", margin:"0", display:"revert"}} src={props.info.Logo_orig} onError={(e)=>{e.target.src = 'https://www.mpinforma.com/images/demo/LOGOS_FECOER/Landing_Logo_Fecoer.png'}}/>          
                            }
                            actions={[
                                <a target="_blank" href={props.info.URL_orig}>
                                    <ActionButton>
                                    Ir a página principal
                                    </ActionButton>
                                </a>,
                            ]}
                        >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Tipo : </strong>{props.info.Tipo_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Ciudad : </strong>{props.info.Ciudad_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}
const CardAudiovisualVideo = (props) => { 
    return(
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:580, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <iframe width="560" height="315" src={props.info.URL_orig} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>          
                            }
                            actions={[
                                <a target="_blank" href={props.info.URL_orig}>
                                    <ActionButton>
                                    Ir a la página oficial
                                    </ActionButton>
                                </a>,
                            ]} 
                        >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Fecha : </strong>{props.info.Fecha}</BookData>
                                          {/* <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL}</BookData> */}
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}

const CardAudio = (props) => { 
    return(
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:400, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <iframe width="100%" height="200" frameborder="0" allowfullscreen="" scrolling="no" src={props.info.URL_orig}></iframe>
                            }
                        >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Fecha : </strong>{props.info.Fecha}</BookData>
                                          {/* <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL}</BookData> */}
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}

const CardProfesional = (props) => { 
    return(
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:800, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <img style={{minWidth:"10%",maxWidth:"300px", padding:"10px 10%", margin:"0", display:"revert"}} src={props.info.URL_orig} onError={(e)=>{e.target.src = 'https://www.mpinforma.com/images/demo/LOGOS_FECOER/Landing_Logo_Fecoer.png'}}/>          
                            }
                            /* actions={[
                                <a target="_blank" href={props.info.URL}>
                                    <ActionButton>
                                    Ver en YouTube
                                    </ActionButton>
                                </a>,
                            ]} */
                        >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData style={{textJustify:"inter-word", textAlign:"justify", paddingRight:"3%"}}><strong style={{color:"#6C0E60"}}>Descripción : </strong>{props.info.Descripcion_orig}</BookData>
                                          {/* <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL}</BookData> */}
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}

const CardInvestigacion = (props) => { 
    return(
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:580, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <InputBar  widthbar="100%" heightbar="20px"/>          
                            }
                            actions={[
                                <a target="_blank" href={props.info.URL_orig}>
                                    <ActionButton>
                                    Ir a página principal
                                    </ActionButton>
                                </a>,
                            ]} 
                        >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Ciudad : </strong>{props.info.Ciudad_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Entidad : </strong>{props.info.Entidad_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
    )
}







/*--------------------------------------------------Cards de Edicion---------------------------------------------------------- */


const CardEdit = (props) => { 
    let [alertdelete, setalertdelete ] = useState(false)
    const topFunction = () => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    useEffect(()=>{
        if(alertdelete === true){
            switch(props.typeData){
                case "Papers":
                    deleteAlert(props.info, props.typeData)
                    setalertdelete(false)
                break
                case "Normas":
                    deleteAlert(props.info, props.typeData)
                    setalertdelete(false)
                break
                case "Plataformas":
                    deleteAlert(props.info, props.typeData)
                    setalertdelete(false)
                break
                case "AudioVisuales":
                    deleteAlert(props.info, props.typeData)
                    setalertdelete(false)
                break
                case "OrganizacionPacientes":
                    deleteAlert(props.info, props.typeData)
                    setalertdelete(false)
                break
                case "Profesionales":
                    deleteAlert(props.info, props.typeData)
                    setalertdelete(false)
                break
                case "Investigacion":
                    deleteAlert(props.info, props.typeData)
                    setalertdelete(false)
                break
            }
        }
        else{
            return null
        }
    })

    return(
        <div>
            {
                props.typeData === "Papers" ?
                
                                <Book>
                                    <Card
                                        key={props.info.id}
                                        style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:700 }}
                                        className="cardbox-shadow"
                                        /* cover={
                                            <InputBar backgroundColor="#f205cb" widthbar="100%" heightbar="20px"/>
                                        } */
                                        actions={[
                                            <Link onClick={topFunction} to={`/biblioteca/${props.info.id}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                                            <Link onClick={topFunction} to={{pathname:`/biblioteca/edit/${props.info.id}`, state: { idType:"Papers" }}} params={{idValue:`${props.info.id}`}}><ActionButton background="#4E6FFF" color="white">Editar &nbsp;<EditFilled  key="edit" /></ActionButton></Link>,
                                            <div onClick={()=>{setalertdelete(true)}}><ActionButton background="#E6384A" color="white">Borrar &nbsp;<DeleteOutlined /></ActionButton></div>,
                                        ]}
                                    >
                                        <Meta
                                        title={<BookTitle>{props.info.titulo_orig}</BookTitle>}
                                        description={
                                            <div>
                                                <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                                <ul>
                                                      <BookData><strong style={{color:"#6C0E60"}}>Autores : </strong>{props.info.Autores_orig}</BookData>
                                                      <BookData><strong style={{color:"#6C0E60"}}>Año : </strong>{props.info.Fecha}</BookData>
                                                      <BookData><strong style={{color:"#6C0E60"}}>Revista : </strong>{props.info.titulo_secundario_orig}</BookData>
                                                      <BookData><strong style={{color:"#6C0E60"}}>Numero : </strong>{props.info.Numero}</BookData>
                                                      <BookData><strong style={{color:"#6C0E60"}}>Volumen : </strong>{props.info.Volumen}</BookData>
                                                      <BookData><strong style={{color:"#6C0E60"}}>Palabras Clave : </strong>{props.info.PalabrasClave_orig}</BookData>
                                                      <BookData><strong style={{color:"#6C0E60"}}>Idioma : </strong>{
                                                          props.info.Idioma == "Espanol" ? "Español" : props.info.Idioma_orig  
                                                      }</BookData>
                                                </ul>
                                            </div>
                                        }
                                        />
                                    </Card>
                                </Book>
                    :
                    props.typeData === "Normas" ?
                    <Book>
                        <Card
                            key={props.info.id}
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400 }}
                            className="cardbox-shadow"
                            cover={
                                <InputBar widthbar="100%" heightbar="20px"/>
                            }
                            actions={[
                                <Link onClick={topFunction} to={`/normativa/${props.info.id}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                                <Link onClick={topFunction} to={{pathname:`/normativa/edit/${props.info.id}`, state: { idType:"Normas" }}} params={{idValue:`${props.info.id}`}}><ActionButton background="#4E6FFF" color="white">Editar &nbsp;<EditFilled  key="edit" /></ActionButton></Link>,
                                <div onClick={()=>{setalertdelete(true)}}><ActionButton background="#E6384A" color="white">Borrar &nbsp;<DeleteOutlined /></ActionButton></div>,
                            ]}
                            >
                            <Meta
                            title={<BookTitle>{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div>
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Entidad : </strong>{props.info.Entidad_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Año : </strong>{props.info.Fecha}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Descripcion : </strong>{props.info.Descripcion_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Tipo de Norma : </strong>{props.info.TipoNorma_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
                    :
                    props.typeData === "Plataformas" ?
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400 }}
                            className="cardbox-shadow"
                            cover={
                                <img style={{minWidth:"10%",maxWidth:"300px", padding:"10px 10%", margin:"0", display:"revert"}} src={props.info.LogoURL_orig} onError={(e)=>{e.target.src = 'https://www.mpinforma.com/images/demo/LOGOS_FECOER/Landing_Logo_Fecoer.png'}}/>
                            }
                            actions={[
                            <Link onClick={topFunction} to={`${props.info.URL_orig}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                            <Link onClick={topFunction} to={{pathname:`/plataforma/edit/${props.info.id}`, state: { idType:"Plataformas" }}} params={{idValue:`${props.info.id}`}}><ActionButton background="#4E6FFF" color="white">Editar &nbsp;<EditFilled  key="edit" /></ActionButton></Link>,
                            <div onClick={()=>{setalertdelete(true)}}><ActionButton background="#E6384A" color="white">Borrar &nbsp;<DeleteOutlined /></ActionButton></div>
                            ]}
                            >
                            <Meta
                            title={<BookTitle>{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div>
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Descripción : </strong>{props.info.Descripcion_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
                    :
                    props.typeData === "AudioVisuales" ?
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400 }}
                            className="cardbox-shadow"
                            cover={
                                <img style={{minWidth:"10%",maxWidth:"300px", padding:"10px 10%", margin:"0", display:"revert"}} src={props.info.Logo} onError={(e)=>{e.target.src = 'https://www.mpinforma.com/images/demo/LOGOS_FECOER/Landing_Logo_Fecoer.png'}}/>  
                            }
                            actions={[
                            <Link onClick={topFunction} to={`${props.info.URL_orig}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                            <Link onClick={topFunction} to={{pathname:`/media/edit/${props.info.id}`, state: { idType:"AudioVisuales" }}} params={{idValue:`${props.info.id}`}}><ActionButton background="#4E6FFF" color="white">Editar &nbsp;<EditFilled  key="edit" /></ActionButton></Link>,
                            <div onClick={()=>{setalertdelete(true)}}><ActionButton background="#E6384A" color="white">Borrar &nbsp;<DeleteOutlined /></ActionButton></div>
                            ]}
                            >
                            <Meta
                            title={<BookTitle>{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div>
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Descripción : </strong>{props.info.Descripcion_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
                    :
                    props.typeData === "OrganizacionPacientes" ?
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:580, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <img style={{minWidth:"10%",maxWidth:"300px", padding:"10px 10%", margin:"0", display:"revert"}} src={props.info.Logo_orig} onError={(e)=>{e.target.src = 'https://www.mpinforma.com/images/demo/LOGOS_FECOER/Landing_Logo_Fecoer.png'}}/>          
                            }
                            actions={[
                            <Link onClick={topFunction} to={`${props.info.URL_orig}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                            <Link onClick={topFunction} to={{pathname:`/organizacion/edit/${props.info.id}`, state: { idType:"OrganizacionPacientes" }}} params={{idValue:`${props.info.id}`}}><ActionButton background="#4E6FFF" color="white">Editar &nbsp;<EditFilled  key="edit" /></ActionButton></Link>,
                            <div onClick={()=>{setalertdelete(true)}}><ActionButton background="#E6384A" color="white">Borrar &nbsp;<DeleteOutlined /></ActionButton></div>    
                            ]}
                            >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Tipo : </strong>{props.info.Tipo_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Ciudad : </strong>{props.info._orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
                    :
                    props.typeData === "Profesionales" ?
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:800, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <img style={{minWidth:"10%",maxWidth:"300px", padding:"10px 10%", margin:"0", display:"revert"}} src={props.info.URL_orig} onError={(e)=>{e.target.src = 'https://www.mpinforma.com/images/demo/LOGOS_FECOER/Landing_Logo_Fecoer.png'}}/>          
                            }
                            actions={[
                            <Link onClick={topFunction} to={`${props.info.URL_orig}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                            <Link onClick={topFunction} to={{pathname:`/profesional/edit/${props.info.id}`, state: { idType:"Profesionales" }}} params={{idValue:`${props.info.id}`}}><ActionButton background="#4E6FFF" color="white">Editar &nbsp;<EditFilled  key="edit" /></ActionButton></Link>,
                            <div onClick={()=>{setalertdelete(true)}}><ActionButton background="#E6384A" color="white">Borrar &nbsp;<DeleteOutlined /></ActionButton></div>    
                            ]}
                            >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData style={{textJustify:"inter-word", textAlign:"justify", paddingRight:"3%"}}><strong style={{color:"#6C0E60"}}>Descripción : </strong>{props.info.Descripcion_orig}</BookData>
                                          {/* <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL}</BookData> */}
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
                    :
                    props.typeData === "Investigacion" ?
                    <Book>
                        <Card
                            key="1"
                            style={{ width: "100%", marginLeft: "1%", marginRight: 0, marginBottom:"4%", minHeight:400, height:580, maxHeight:700 }}
                            className="cardbox-shadow"
                            cover={
                                <InputBar  widthbar="100%" heightbar="20px"/>          
                            }
                            actions={[
                            <Link onClick={topFunction} to={`${props.info.URL_orig}`} params={{idValue:`${props.info.id}`}}><ActionButton>Ver mas &nbsp;<FileSearchOutlined key="seemore" /></ActionButton></Link>,
                            <Link onClick={topFunction} to={{pathname:`/investigacion/edit/${props.info.id}`, state: { idType:"Investigacion" }}} params={{idValue:`${props.info.id}`}}><ActionButton background="#4E6FFF" color="white">Editar &nbsp;<EditFilled  key="edit" /></ActionButton></Link>,
                            <div onClick={()=>{setalertdelete(true)}}><ActionButton background="#E6384A" color="white">Borrar &nbsp;<DeleteOutlined /></ActionButton></div>    
                            ]} 
                            >
                            <Meta
                            title={<BookTitle >{props.info.Nombre_orig}</BookTitle>}
                            description={
                                <div >
                                    <Divider style={{width:"100%", alignContent:"center", height:"2px", margin:"3% 0%", backgroundColor:"#6C0E60" }} variant="middle" />
                                    <ul>
                                          <BookData><strong style={{color:"#6C0E60"}}>Ciudad : </strong>{props.info.Ciudad_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>Entidad : </strong>{props.info.Entidad_orig}</BookData>
                                          <BookData><strong style={{color:"#6C0E60"}}>URL : </strong>{props.info.URL_orig}</BookData>
                                    </ul>
                                </div>
                            }
                            />
                        </Card>
                    </Book>
                    :
                    <div></div>
            }
        </div>
    )
}



export {CardLibrary, CardNormas, CardPlatform, CardOrganizacion, CardEdit, CardAudiovisualVideo, CardAudio, CardProfesional, CardInvestigacion}